import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import '../src/i18n';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import PurchasesPage from './pages/PurchasesPage';
import SalesPage from './pages/SalesPage';
import LabourPage from './pages/LabourPage';
import HarvestPage from './pages/HarvestPage';
import StockPage from './pages/StockPage';
import ContactsPage from './pages/ContactsPage';
import FieldsPage from './pages/FieldsPage';
import SettingsPage from './pages/SettingsPage';
import PaymentsPage from './pages/PaymentsPage';
import WorkOrdersPage from './pages/WorkOrdersPage';
import PlantingsPage from './pages/PlantingsPage';
import YevmiyelerPage from './pages/YevmiyelerPage';
import PlantingDetailPage from './pages/PlantingDetailPage';
import NotebookPage from './pages/NotebookPage';
import OnboardingPage from './pages/OnboardingPage';

import './App.css';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: { background: '#1a2e1a', color: '#e8f5e8', borderRadius: '12px' },
          }}
        />
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="purchases" element={<PurchasesPage />} />
            <Route path="sales" element={<SalesPage />} />
            <Route path="labour" element={<LabourPage />} />
            <Route path="harvest" element={<HarvestPage />} />
            <Route path="stock" element={<StockPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="fields" element={<FieldsPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="work-orders" element={<WorkOrdersPage />} />
            <Route path="plantings" element={<PlantingsPage />} />
            <Route path="plantings/:id" element={<PlantingDetailPage />} />
            <Route path="yevmiyeler" element={<YevmiyelerPage />} />
            <Route path="notebook" element={<NotebookPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
